import React from 'react';
import Icon from './AppIcon';

const Footer = ({ practitionerData = null }) => {
  // Use practitionerData if available, otherwise fallback to default Dr. Touati info
  const displayName = practitionerData?.practitionerName || 'Dr Arnaud Touati';
  const displayPractice = practitionerData?.practiceName || 'Endodontie exclusive';
  const displayAddress = practitionerData?.address || '15 rue Lavoisier';
  const displayCity = practitionerData?.city || 'Besançon';
  const displayPostalCode = practitionerData?.postalCode || '25000';
  const displayPhone = practitionerData?.phone || '03 63 42 92 58';
  const displayEmail = practitionerData?.email || 'cabinetdentaire.lavoisier@gmail.com';

  return (
    <footer className="app-footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3 className="footer-title">Cabinet d'endodontie – {displayName}</h3>
          <p className="footer-subtitle">{displayPractice} – traitements, reprises et chirurgies sous microscope opératoire</p>
        </div>
        
        <div className="footer-contact">
          <div className="contact-item">
            <Icon name="MapPin" size={16} className="contact-icon" />
            <span>{displayAddress}, {displayPostalCode} {displayCity}</span>
          </div>
          <div className="contact-item">
            <Icon name="Phone" size={16} className="contact-icon" />
            <span>{displayPhone}</span>
          </div>
          <div className="contact-item">
            <Icon name="Mail" size={16} className="contact-icon" />
            <span>{displayEmail}</span>
          </div>
        </div>

        <div className="footer-compliance">
          <div className="compliance-badge">
            <Icon name="Shield" size={16} className="compliance-icon" />
            <div className="compliance-text">
              <strong>Conformité RGPD</strong>
              <p>Les données saisies sont traitées uniquement côté client. Aucune donnée patient n'est stockée sur un serveur ou conservée après génération du PDF.</p>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .app-footer {
          background: rgba(15, 15, 15, 0.8);
          backdrop-filter: blur(40px) saturate(180%);
          -webkit-backdrop-filter: blur(40px) saturate(180%);
          border-top: 1px solid rgba(255, 255, 255, 0.06);
          padding: 2rem 1rem;
          margin-top: auto;
          position: relative;
          z-index: 10;
        }

        .footer-content {
          max-width: 1280px;
          margin: 0 auto;
          display: flex;
          flex-direction: column;
          gap: 1.5rem;
        }

        .footer-section {
          display: flex;
          flex-direction: column;
          gap: 0.5rem;
        }

        .footer-title {
          font-size: 1rem;
          font-weight: 600;
          color: #F5F5F7;
          margin: 0;
        }

        .footer-subtitle {
          font-size: 0.875rem;
          color: #98989D;
          margin: 0;
          line-height: 1.5;
        }

        .footer-contact {
          display: flex;
          flex-direction: column;
          gap: 0.75rem;
        }

        .contact-item {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          font-size: 0.875rem;
          color: #D1D1D6;
        }

        .contact-icon {
          color: #4A90E2;
          flex-shrink: 0;
        }

        .footer-compliance {
          padding-top: 1rem;
          border-top: 1px solid rgba(255, 255, 255, 0.06);
        }

        .compliance-badge {
          display: flex;
          gap: 0.75rem;
          align-items: flex-start;
        }

        .compliance-icon {
          color: #4A90E2;
          flex-shrink: 0;
          margin-top: 0.125rem;
        }

        .compliance-text {
          flex: 1;
        }

        .compliance-text strong {
          display: block;
          font-size: 0.875rem;
          font-weight: 600;
          color: #F5F5F7;
          margin-bottom: 0.25rem;
        }

        .compliance-text p {
          font-size: 0.75rem;
          color: #98989D;
          margin: 0;
          line-height: 1.5;
        }

        .footer-text {
          font-size: 0.875rem;
          color: #A8A8AD;
          margin: 0;
        }

        .footer-link {
          color: #A8A8AD;
          text-decoration: none;
          transition: color 0.3s ease;
          font-weight: 500;
        }

        .footer-link:hover {
          color: #4A90E2;
        }

        @media (min-width: 768px) {
          .footer-content {
            gap: 2rem;
          }

          .footer-contact {
            flex-direction: row;
            flex-wrap: wrap;
            gap: 1.5rem;
          }

          .footer-title {
            font-size: 1.125rem;
          }
        }

        @media (min-width: 1024px) {
          .app-footer {
            padding: 2.5rem 1.5rem;
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer;